import { cn } from "@marketing-sites/utils/cn";

export type DotDecoratorsVariant =
  | "corners"
  | "border"
  | "sides"
  | "top"
  | "top-left"
  | "bottom";

export interface DotDecoratorsProps {
  variant?: DotDecoratorsVariant;
  className?: string;
}

const CORNERS = [
  "top-0 left-0",
  "top-0 right-0",
  "bottom-0 left-0",
  "bottom-0 right-0",
];

const BORDER = [
  // Left edge — 4 evenly spaced
  "top-0 left-0",
  "top-1/3 left-0 hidden md:block",
  "top-2/3 left-0 hidden md:block",
  "bottom-0 left-0",
  // Right edge — 4 evenly spaced
  "top-0 right-0",
  "top-1/3 right-0 hidden md:block",
  "top-2/3 right-0 hidden md:block",
  "bottom-0 right-0",
  // Top & bottom center
  "top-0 left-1/2 hidden md:block",
  "bottom-0 left-1/2 hidden md:block",
];

const SIDES = [
  // Left edge — 3 evenly spaced
  "top-0 left-0",
  "top-1/2 left-0",
  "bottom-0 left-0",
  // Right edge — 3 evenly spaced
  "top-0 right-0",
  "top-1/2 right-0",
  "bottom-0 right-0",
];

const TOP = ["top-0 left-0", "top-0 right-0"];

const TOP_LEFT = ["top-0 left-0"];

const BOTTOM = ["bottom-0 left-0", "bottom-0 right-0"];

const POSITIONS = {
  corners: CORNERS,
  border: BORDER,
  sides: SIDES,
  top: TOP,
  "top-left": TOP_LEFT,
  bottom: BOTTOM,
};

export default function DotDecorators({
  variant = "corners",
  className,
}: DotDecoratorsProps) {
  return (
    <div
      aria-hidden
      data-dot-decorators
      className={cn(
        "text-clay pointer-events-none absolute inset-0 m-3 xl:m-4",
        className,
      )}
    >
      {POSITIONS[variant].map((pos) => (
        <span key={pos} className={cn("absolute size-2 bg-current", pos)} />
      ))}
    </div>
  );
}
